import { useEffect, useRef } from 'react';

interface RootProps {
  bgColor?: string;
  bgImage?: string;
  paddingTop?: string;
  paddingBottom?: string;
}

const useApplyBodyStyle = (props: RootProps) => {
  const root = useRef(document.documentElement);
  useEffect(() => {
    if (props.bgColor) {
      root.current.style.setProperty('--bg-color', props.bgColor);
    }
    if (props.bgImage) {
      root.current.style.setProperty('--bg-image', props.bgImage);
    }
    if (props.paddingTop) {
      root.current.style.setProperty('--padding-top', props.paddingTop);
    }
    if (props.paddingBottom) {
      root.current.style.setProperty('--padding-bottom', props.paddingBottom);
    }
    return () => {
      if (props.bgColor) {
        root.current.style.removeProperty('--bg-color');
      }
      if (props.bgImage) {
        root.current.style.removeProperty('--bg-image');
      }
      if (props.paddingTop) {
        root.current.style.removeProperty('--padding-top');
      }
      if (props.paddingBottom) {
        root.current.style.removeProperty('--padding-bottom');
      }
    };
  }, [props]);
};

export default useApplyBodyStyle;
